import React from 'react';
import PropTypes from 'prop-types';
import PlayIcon from '../../static/images/play.svg';
import OverlayButton from '../overlay-button/overlay-button';
import renderPlayButtonText from '../overlay-texts/play-button-text';

function PlayButton({
  channel,
  video,
  currentSiteUser,
  onClick,
  showText,
  className,
}) {
  // non empty text means that user can play either video or trailer
  const text = renderPlayButtonText({
    channel,
    video,
    currentSiteUser,
  });

  return text ? (
    <OverlayButton
      onClick={onClick}
      icon={PlayIcon}
      text={showText ? text : undefined}
      className={className}
    />
  ) : null;
}

PlayButton.propTypes = {
  channel: PropTypes.object.isRequired,
  video: PropTypes.object.isRequired,
  currentSiteUser: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default PlayButton;
